// Middleware
export const API_MIDDLEWARE = 'middleware::API_CALL';

// Session
export const LOGIN = 'session::LOGIN';

// UI
export const FETCHING_START = 'ui::FETCHING_START';
export const FETCHING_STOP = 'ui::FETCHING_STOP';
